/**
 * Single source of truth for "is this User-Agent one of the four Hungryroot
 * mobile app builds?". Both the client-side `useIsEmbeddedWebView` hook and
 * the SSR enrollment path's `isEmbeddedWebViewFromUserAgent` delegate here so
 * the two checks cannot drift apart.
 *
 * Generic Android WebViews (Facebook / Instagram in-app browsers, etc.) are
 * intentionally NOT matched. If you need to detect them for a specific UI
 * concern, do so at the call site — DO NOT widen this pattern. Widening it
 * silently changes variant assignment for every experiment whose `exclude`
 * function reads `isEmbeddedWebView`, and creates an asymmetry between SSR
 * and client enrollment paths (which is the bug this utility exists to
 * prevent).
 */
export const HUNGRYROOT_APP_USER_AGENT_PATTERN_SOURCE =
  'com\\.hungryroot\\.ios\\.prod|com\\.hungryroot\\.android\\.prod|com\\.hungryroot\\.android\\.staging|com\\.hungryroot\\.ios\\.staging';

const HUNGRYROOT_APP_USER_AGENT_PATTERN = new RegExp(
  HUNGRYROOT_APP_USER_AGENT_PATTERN_SOURCE,
  'i'
);

export function isHungryrootAppUserAgent(userAgent: string): boolean {
  return HUNGRYROOT_APP_USER_AGENT_PATTERN.test(userAgent);
}
